export interface FoldOthersNamesInput {
  /** 렌더된 그리드 폭(px) — 칸 글자 크기(cqw)의 기준 */
  gridWidth: number;
  /** 렌더된 한 줄 높이(px) */
  rowHeight: number;
  othersCount: number;
  /** 숫자 아래 공휴일 이름 줄이 있는가 */
  holiday?: boolean;
  /** 숫자 아래 월급일 이름표가 있는가 */
  payday?: boolean;
}

/** 칸 CSS 와 같은 값 — CalendarHeatmapCell.css 의 cell·holidayName·paydayName·othersName·cellWithNames */
const NUMBER_FONT = (gridWidth: number) => Math.min(gridWidth * 0.05, 20);
/** 숫자 라인박스 = 글자 × 1.225 (grid.minHeight 주석의 chromium 실측 24.5px @20px) */
const NUMBER_LINE_RATIO = 1.225;
const LABEL_FONT = (gridWidth: number) => Math.min(Math.max(gridWidth * 0.024, 7), 11);
const LABEL_LINE_RATIO = 1.15;
const PAYDAY_CHIP_HEIGHT = 13;
const STACK_GAP = 2;
const NAMES_GAP = 1;

/**
 * 휴가자 이름을 인원 배지로 접을지. 날짜 숫자 아래로 공휴일 이름·월급일 이름표·휴가자 이름(2명 이하는
 * 전원, 3명 이상은 1명 + 「+N」 두 줄)이 쌓이는데, 그 높이가 줄 높이를 넘으면 이름만 접는다 — 숫자와
 * 월급일 이름표는 접지 않는다(시안 4절, 팀장 답글 2026-10-14). 휴가자는 배지·칸 버튼 이름·날짜 상세에 남는다.
 */
export function foldOthersNames({
  gridWidth,
  rowHeight,
  othersCount,
  holiday = false,
  payday = false,
}: FoldOthersNamesInput): boolean {
  if (othersCount === 0) return false;
  const labelLine = LABEL_FONT(gridWidth) * LABEL_LINE_RATIO;
  const nameLines = Math.min(othersCount, 2);
  const stacked = [
    holiday ? labelLine : 0,
    payday ? PAYDAY_CHIP_HEIGHT : 0,
    nameLines * labelLine + (nameLines - 1) * NAMES_GAP,
  ].filter((height) => height > 0);
  const needed =
    NUMBER_FONT(gridWidth) * NUMBER_LINE_RATIO +
    stacked.reduce((sum, height) => sum + STACK_GAP + height, 0);
  return needed > rowHeight;
}
